import {isObject, isPlainObject, truncate} from "lodash";
const UtilityMixin = {
    data() {
        return {
            countries: []
        }
    },
    computed: {
        linkToJob() {
            const resolved = this.$router.resolve({
                name: this.$route.name
            })
            
            const unencodedUrl = `${window.location.origin}/h/advanced#${resolved.route.path}`
            const encodedUrl = `${window.location.origin}${this.UtilityMixin().encodeUrl('/h/advanced#' + resolved.route.path)}`
            return {
                unencodedUrl,
                encodedUrl
            }
        }
    },
    methods: {
        UtilityMixin() {
            let that = this
            return {
                linkedInSharingLink(link = null) {
                    return `https://www.linkedin.com/sharing/share-offsite/?url=${link || that.linkToJob.encodedUrl}`
                },
                facebookSharingLink(link = null) {
                    return `https://www.facebook.com/sharer/sharer.php?u=${link || that.linkToJob.encodedUrl}`
                },
                twitterSharingLink(link = null) {
                    return `https://www.twitter.com/intent/tweet?url=${link || that.linkToJob.encodedUrl}`
                },
                messengerSharingLink() {
                    return `fb-messenger://share/?link=${that.linkToJob.encodedUrl}`
                },
                emailSharingLink({ subject: subject="Link I want to share with you", body: body = `View it on this link ${that.linkToJob.unencodedUrl}` }) {
                    return `mailto:?subject=${subject}&body=${body};`
                },
                whatsAppSharingLink({ text : text= `I want to share this link ${that.linkToJob.encodedUrl} with you` }) {
                    return `https://api.whatsapp.com/send?text=${text}`
                },
                copyLinkToClipboard: (link) => {
                    navigator.clipboard.writeText(link || that.linkToJob.unencodedUrl);
                    this.$alert.toast('success', '', 'Link copied to clipboard')
                },
                encodeUrl: (url) => {
                    return window.encodeURIComponent(url)
                },
                formatCurrency: (value) => {
                    const formatter =  new Intl.NumberFormat('en-US')
                    return formatter.format(value)
                },
                capitalizeFirstLetterOfWord: (word) => {
                    const firstLetter = word.substring(0, 1)
                    const restOfLetters = word.substring(1).toLowerCase()
                    return `${firstLetter.toUpperCase()}${restOfLetters}`
                },
                formatISODateString(ISODate) {
                    return new Date(ISODate).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    })
                },

                /**
                 * @param {time} - the time string in the format **:**:**
                 * @return {String} - the time format as converted by moment
                 */
                // the arrow function is used here because the context of this in the utility methods mixin is not the Vue instance
                // the arrow function will make the this keyword to refer to the Vue instance
                stripTimeStringToHumanLanguage: (time) => {
                    const timeObject = this.UtilityMixin().convertColonSeparatedTimeToTimeObject(time)
                    return this.$moment.duration(timeObject).humanize()
                },

                 /**
                 * @param {time} - the time string in the format **:**:**
                 * @return {Object} - the timeObject that will be formatted by moment to human language
                 */
                convertColonSeparatedTimeToTimeObject: (time) => {
                    // the time comes in the format **:**:** e.g 120:10:22
                    const timeOutput = time?.split(':')
                    const seconds = timeOutput[2]
                    const minutes = timeOutput[1]
                    const hours = timeOutput[0]
                    const timeObject = {
                        minutes,
                        seconds,
                        hours
                    }
                    return timeObject
                },

                calculatePercentage({ total, value, numberOfDecimalPlaces: numberOfDecimalPlaces = 1 }) {
                    // to prevent NaN error
                    if (!total || !value) {
                        return 0
                    }
                    const percentage = (value * 100) / total
                    
                    if (Number.isInteger(percentage)) {
                        return percentage
                    }
                    return percentage.toFixed(numberOfDecimalPlaces)
                },
                
                convertStrToSnakeCase(str = ''){
                    if (!str) return '';

                    return str.split(' ')
                        .join('_').toLowerCase()
                        .replace(/[^a-z_0-9]/g, "")
                },

                convertPdfStreamToFileUrl(pdfStream) {
                    const file = new Blob(
                        [
                            pdfStream
                        ],
                        {
                            type: 'application/pdf'
                        }
                    );
                    const fileURL = URL.createObjectURL(file);
                    return fileURL
                },
                
                slugifyStr(str = ''){
                    if (!str) return '';
                    
                    return str.split(/[\s-]+/)
                          .join('-').toLowerCase()
                          .replace(/[^a-z0-9-]/g, '')
                },

                arrayUnique(array = [], key = 'id'){
                    if (!array.length) return []

                    // Check if array of objects
                    if (_.isObject(_.first(array))){
                        /*
                        * if array of objects key must be supplied, default is ID
                        * Based on our use case
                        * */
                        return [...new Map(array.map(item =>
                            [item[key], item])).values()]
                    }

                    // For primitives
                    return _.uniq(array)
                },

                clearStorageKeys(keys = []){
                    for(let i = 0; i < keys.length; i++){
                        if (isObject(keys[i]) && isPlainObject(keys[i])){
                            sessionStorage.removeItem(keys[i].key)
                        }else {
                            sessionStorage.removeItem(keys[i])
                        }
                    }
                },

                findCountryUsingCountryId: (id) => {
                    if (id) {
                        const country = this.countries.find(country => country.id === id)

                        if (country) {
                            return country.name
                        }
                    }
                    return ''
                },
                appendTextToEditor(editorInstance, text) {
                    text = '{'+text+'}';
                    editorInstance.model.change( writer => {
                        const insertPosition = editorInstance.model.document.selection.getFirstPosition();
                        writer.insertText(text, insertPosition);
                    });
                },
                numberWithCommas(number) {
                    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
                truncateFileName(fileName, truncationLength) {
                    const indexOfDot = fileName.lastIndexOf('.')
                    const fileExtension = fileName.substring(indexOfDot)

                    const truncatedFileNameWithoutFileExtension = fileName.substring(0, truncationLength)
                    if (truncatedFileNameWithoutFileExtension.length < truncationLength) {
                        return fileName
                    }
                    return `${truncatedFileNameWithoutFileExtension}...${fileExtension}`
                },
                abbreviateNumber(number, decPlaces=1) {
                  // 2 decimal places => 100, 3 => 1000, etc
                  decPlaces = Math.pow(10, decPlaces);

                  // Enumerate number abbreviations
                  let abbrev = ["k", "m", "b", "t"];

                  // Go through the array backwards, so we do the largest first
                  for (let i = abbrev.length - 1; i >= 0; i--) {

                    // Convert array index to "1000", "1000000", etc
                    let size = Math.pow(10, (i + 1) * 3);

                    // If the number is bigger or equal do the abbreviation
                    if (size <= number) {
                      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
                      // This gives us nice rounding to a particular decimal place.
                      number = Math.round(number * decPlaces / size) / decPlaces;

                      // Handle special case where we round up to the next abbreviation
                      if ((number == 1000) && (i < abbrev.length - 1)) {
                        number = 1;
                        i++;
                      }

                      // Add the letter for the abbreviation
                      number += abbrev[i];

                      // We are done... stop
                      break;
                    }
                  }

                  return number;
                },
                truncateString(string, truncationLength) {
                    if (typeof string !== 'string') {
                        string = string.toString()
                    }
                    if (string.length <= truncationLength) {
                        return string
                    }
                    const truncatedString = string.substring(0, truncationLength)
                    return `${truncatedString}...`
                }
            }
        }
    }
}

export default UtilityMixin;
